// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nj-0";